import { render, staticRenderFns } from "./LiteratureList.vue?vue&type=template&id=23afab5d&scoped=true"
import script from "./LiteratureList.vue?vue&type=script&lang=js"
export * from "./LiteratureList.vue?vue&type=script&lang=js"
import style0 from "./LiteratureList.vue?vue&type=style&index=0&id=23afab5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23afab5d",
  null
  
)

export default component.exports